import { DocLayout } from './DocLayout'

export default function PrivacyPage() {
  return (
    <DocLayout title="Privacyverklaring" updated="Laatst bijgewerkt: juli 2026">
      <p>
        RUST bewaart je planning, herinneringen, dagboek en gezondheidsgegevens zodat jij ze
        overzichtelijk bij elkaar hebt. In deze verklaring lees je welke gegevens we verwerken,
        waarom, en welke rechten je hebt.
      </p>

      <h2>Welke gegevens we bewaren</h2>
      <ul>
        <li>Accountgegevens: je naam, e-mailadres en rol (cliënt of begeleider).</li>
        <li>
          Inhoud die je zelf invoert: planning, notities, dagboek, plaatsen van spullen,
          ademhalingssessies en gezondheidsregistraties.
        </li>
        <li>
          Begeleiderskoppelingen: welke begeleider aan welke cliënt is gekoppeld, en de status van
          die koppeling.
        </li>
        <li>Technische gegevens die nodig zijn om de app te laten werken, zoals sessie-informatie.</li>
      </ul>

      <h2>Waarom we deze gegevens gebruiken</h2>
      <ul>
        <li>Om de app te laten doen wat je vraagt: je gegevens opslaan en op al je apparaten tonen.</li>
        <li>Om begeleiders alleen toegang te geven tot cliënten die daarvoor toestemming hebben gegeven.</li>
        <li>Om de veiligheid en betrouwbaarheid van de dienst te bewaken.</li>
      </ul>

      <h2>Wie er bij je gegevens kan</h2>
      <p>
        Jij bepaalt wie er meekijkt. Een begeleider ziet alleen gegevens van cliënten met een
        actieve koppeling, en alleen datgene wat bij de begeleiding hoort. Je dagboek is privé en
        wordt nooit met begeleiders gedeeld. We verkopen je gegevens niet en gebruiken ze niet voor
        advertenties.
      </p>

      <h2>Beveiliging</h2>
      <p>
        Je gegevens liggen versleuteld opgeslagen bij onze cloudprovider (Supabase) in een
        beveiligde omgeving. Toegang wordt server-side afgedwongen: elke aanvraag controleert wie
        je bent en welke rol je hebt. Afbeeldingen en bewijsvideo&apos;s staan in afgeschermde
        opslag en zijn alleen tijdelijk te openen via beveiligde links.
      </p>

      <h2>Jouw rechten</h2>
      <ul>
        <li>Je kunt al je gegevens exporteren vanuit de app (Meer → Gegevens).</li>
        <li>Je kunt je account en alle bijbehorende gegevens verwijderen via de app.</li>
        <li>Je kunt een koppeling met een begeleider op elk moment intrekken.</li>
      </ul>

      <h2>Vragen</h2>
      <p>
        Heb je een vraag over je privacy of wil je gebruikmaken van je rechten? Mail ons via{' '}
        <a href="mailto:support@rust.mobi" style={{ color: 'var(--soft-blue)' }}>
          support@rust.mobi
        </a>
        . Je kunt ook een klacht indienen bij de Autoriteit Persoonsgegevens.
      </p>
    </DocLayout>
  )
}
